import { actionType } from './action';

export const InitialState = {
    profile: {}
}

function setUserPrincipal(preState, { profile }) {
    return {
        ...preState,
        profile
    }
}

const reducer = (preState = InitialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionType.SET_USER_PRINCIPAL:
            return setUserPrincipal(preState, payload);

        case actionType.ACCEPT_FUNDER_APPLICANT:            
            return {
                ...preState,
                profile: {
                    ...preState.profile,
                    status: 'normal',
                    userRole: 'funder'
                }
            };

        default:
            return preState;
    }
}

export default reducer;